import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'delete_lists_form';
export const useDeleteListsFormTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  delete_lists_form: {
    title: 'Удалить список(и)',
    subtitle: 'Выберите что сделать с содержимым списка',
    options: {
      delete_content: 'Удалить содержимое',
      detach_content: 'Не удалять содержимое (только открепить)',
    },
    actions: {
      delete: 'Удалить список',
      cancel: 'Отмена',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  delete_lists_form: {
    title: 'Delete list(s)',
    subtitle: 'Choose what to do with the list content',
    options: {
      delete_content: 'Delete content',
      detach_content: 'Keep content (detach only)',
    },
    actions: {
      delete: 'Delete list',
      cancel: 'Cancel',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  delete_lists_form: {
    title: 'Excluir lista(s)',
    subtitle: 'Escolha o que fazer com o conteúdo da lista',
    options: {
      delete_content: 'Excluir conteúdo',
      detach_content: 'Manter conteúdo (apenas desanexar)',
    },
    actions: {
      delete: 'Excluir lista',
      cancel: 'Cancelar',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  delete_lists_form: {
    title: 'Eliminar lista(s)',
    subtitle: 'Elija qué hacer con el contenido de la lista',
    options: {
      delete_content: 'Eliminar contenido',
      detach_content: 'Mantener contenido (solo desvincular)',
    },
    actions: {
      delete: 'Eliminar lista',
      cancel: 'Cancelar',
    },
  },
}) : {}) as Record<string, unknown>;
